function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Helpers = function () {
    function Helpers() {
        _classCallCheck(this, Helpers);
    }

    Helpers.getClassName = function getClassName(defaultClass, propsClass) {
        var className = defaultClass;
        if (propsClass) {
            className = className + " " + propsClass;
        }
        return className;
    };

    return Helpers;
}();

export default Helpers;